import { Navigate } from 'react-router-dom';

export default function CatalogPage() {
  return <Navigate to="/search" replace />;
}
